module.exports = __webpack_public_path__ + "img/dagee-logo.e047423d.png";